import type {_ActionsTree} from 'pinia';
import type {ToastStoreState, ToastStoreStateOption} from '@/store/toast/state';

export interface ToastStoreActions extends _ActionsTree {
    openToast: (options: ToastStoreStateOption) => void;
    closeToast: () => void;
}

export const actions: ToastStoreActions | ToastStoreState = {
    openToast(options: ToastStoreStateOption): void {
        const that: ToastStoreState = this as ToastStoreState;
        that.show = true;
        that.options = options;
    },

    closeToast(): void {
        this.show = false;
    }
};
